import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/delete-box-red.svg'


const _hoisted_1 = { class: "plotting-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Tambah Plot Kondektur")
], -1)
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = { class: "w-3/4" }
const _hoisted_5 = { class: "flex items-center justify-between mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Tambah Bus dan Tanggal"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Pilih nopol yang tersedia, dan masukkan tanggal.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Simpan'), -1)
const _hoisted_8 = { class: "flex items-center justify-between border-grey-2 rounded-lg px-4 py-3 mb-5" }
const _hoisted_9 = { class: "flex items-center gap-4" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-xl font-bold" }
const _hoisted_12 = { class: "border-grey-2 rounded-lg px-4 py-3" }
const _hoisted_13 = { class: "flex items-center justify-between mb-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Tabel Plot Kondektur"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Tabel dibawah merupakan plotting untuk kondektur diatas ")
], -1)
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah'), -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-11 gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey required" }, "NOPOL"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey required" }, "TANGGAL"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey required" }, "JAM (PP)"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey" }, "SOPIR"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey" }, "PEMBANTU"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-sm font-bold text-grey" }, "AKSI")
], -1)
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_20 = { class: "col-span-2" }
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_22 = { class: "col-span-2" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = { class: "col-span-2" }
const _hoisted_27 = { class: "col-span-2" }
const _hoisted_28 = { class: "flex items-center justify-center" }
const _hoisted_29 = {
  key: 0,
  src: _imports_0,
  alt: "delete",
  class: "cursor-not-allowed",
  style: {"width":"35px","height":"35px"}
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "w-1/4" }
const _hoisted_32 = { class: "mb-5" }
const _hoisted_33 = { class: "text-2xl font-bold" }
const _hoisted_34 = { class: "text-base font-normal" }
const _hoisted_35 = {
  class: "w-full my-4",
  style: {"height":"150px","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w-full grid grid-cols-2 gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "PP")
], -1)
const _hoisted_37 = { class: "text-center text-grey text-base font-normal" }
const _hoisted_38 = { class: "text-center text-grey text-base font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Field = _resolveComponent("Field")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpTabView = _resolveComponent("HjpTabView")!
  const _component_KondekturActiveScheduleList = _resolveComponent("KondekturActiveScheduleList")!
  const _component_KondekturLog = _resolveComponent("KondekturLog")!
  const _component_Form = _resolveComponent("Form", true)!
  const _component_SelectConductorForm = _resolveComponent("SelectConductorForm")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_HjpAlertModal = _resolveComponent("HjpAlertModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema,
          "initial-values": _ctx.initialValue,
          class: "form-container",
          validateOnMount: true
        }, {
          default: _withCtx(({ errors, values, setFieldValue, meta }) => [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", null, [
                        _createVNode(_component_Button, {
                          class: "mb-2 sm:mb-0 flex gap-2",
                          type: "submit"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "self-baseline",
                            src: require('@/assets/img/icon/conductor-blue.svg'),
                            style: {"min-width":"40px","height":"40px"},
                            alt: ""
                          }, null, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(`${_ctx.store.state.plotting.selectedConductor.IdCardNumber} -
                                      ${_ctx.store.state.plotting.selectedConductor.Fullname}`), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "text-primary text-base font-semibold cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFormDialog && _ctx.openFormDialog(...args)))
                      }, "Ganti Kondektur ")
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_FieldArray, { name: "data" }, {
                        default: _withCtx(({ fields, push, remove, prepend }) => [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", null, [
                              _createVNode(_component_Button, {
                                class: "flex gap-2",
                                onClick: ($event: any) => (prepend(_ctx.defaultValue))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.icon.svg.plusEva
                                  }, null, 8, _hoisted_15),
                                  _hoisted_16
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            class: "invalid-feedback mb-5",
                            name: `data`
                          }),
                          _createElementVNode("div", null, [
                            _hoisted_17,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (dataX, indexX) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: indexX,
                                class: "grid grid-cols-11 gap-4 pb-1 mb-3"
                              }, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_Field, {
                                    id: `data[${indexX}].vehicle`,
                                    name: `data[${indexX}].vehicle`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_component_SelectFetch, _mergeProps(field, {
                                        modelValue: field.value,
                                        id: `nopol-${indexX}`,
                                        inputId: `bus-${indexX}`,
                                        endpoint: "/management/v1/MsVehicle",
                                        searchCustom: [['activeOnly', '=', true], ['isHasTrayek', '=', true], ['trayekTypeCode', '=', 'REG'], ['orderByHasTrayek', '=', false]],
                                        fieldLabel: (v) => v.Nopol,
                                        placeholder: 'Pilih Bus',
                                        clearable: false,
                                        searchFields: ['Nopol'],
                                        classname: 'custom-select',
                                        "onUpdate:modelValue": (v) => { _ctx.changeVehicle(v, indexX, setFieldValue); setFieldValue(`data[${indexX}].time`, null) }
                                      }), null, 16, ["modelValue", "id", "inputId", "fieldLabel", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(errors[`data[${indexX}].vehicle`]), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_Field, {
                                    id: `data[${indexX}].date`,
                                    name: `data[${indexX}].date`
                                  }, {
                                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                                      _createVNode(_component_DatePicker, _mergeProps(field, {
                                        "onUpdate:modelValue": (val) => _ctx.onUpdateDriver(values.data[indexX].driver, val),
                                        masks: {
                            input: 'DD/MM/YYYY'
                          },
                                        "min-date": new Date(new Date().setDate(new Date().getDate()))
                                      }), {
                                        default: _withCtx(({ togglePopover }) => [
                                          _createVNode(_component_InputText, {
                                            id: "end-date",
                                            placeholder: "Pilih Tanggal",
                                            readonly: true,
                                            value: values.data[indexX].date ? `${_ctx.moment(values.data[indexX].date.toString()).format('DD MMMM YYYY')}` : values.data[indexX].date,
                                            class: _normalizeClass([`input-default`, "input-primary"]),
                                            onClick: togglePopover
                                          }, null, 8, ["value", "onClick"])
                                        ]),
                                        _: 2
                                      }, 1040, ["onUpdate:modelValue", "min-date"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(errors[`data[${indexX}].date`]), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_Field, {
                                    id: `data[${indexX}].time`,
                                    name: `data[${indexX}].time`
                                  }, {
                                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                                      _createVNode(_component_v_select, _mergeProps({
                                        class: "select-default custom-select",
                                        placeholder: "Pilih Jam (PP)",
                                        clearable: true,
                                        disabled: !Boolean(values.data[indexX].vehicle),
                                        options: values.data[indexX].optionTime
                                      }, field, {
                                        modelValue: field.value
                                      }), {
                                        "no-options": _withCtx(({ searching, loading }) => [
                                          searching
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Tidak ada data ditemukan. "))
                                            : _createCommentVNode("", true),
                                          loading
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, " Tidak ada data ditemukan. "))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1040, ["disabled", "options", "modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(errors[`data[${indexX}].time`]), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_component_Field, {
                                    id: `data[${indexX}].driver`,
                                    name: `data[${indexX}].driver`
                                  }, {
                                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                                      _createVNode(_component_SelectFetch, _mergeProps(field, {
                                        modelValue: field.value,
                                        id: `sopir-${indexX}`,
                                        "input-id": "class-input",
                                        endpoint: "/management/v1/User/all-user",
                                        searchCustom: [['activeOnly', '=', true], ['roles', '=', 'Driver']],
                                        fieldLabel: (v) => v.Fullname,
                                        "onUpdate:modelValue": (val) => _ctx.onUpdateDriver(val, values.data[indexX].date),
                                        placeholder: 'Pilih Sopir',
                                        clearable: false,
                                        searchFields: ['Fullname'],
                                        classname: 'custom-select'
                                      }), null, 16, ["modelValue", "id", "fieldLabel", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_Field, {
                                    id: `data[${indexX}].helper`,
                                    name: `data[${indexX}].helper`
                                  }, {
                                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                                      _createVNode(_component_SelectFetch, _mergeProps(field, {
                                        modelValue: field.value,
                                        id: `pembantu-${indexX}`,
                                        "input-id": "class-input",
                                        endpoint: "/management/v1/User/all-user",
                                        searchCustom: [['activeOnly', '=', true], ['roles', '=', 'Helper']],
                                        fieldLabel: (v) => v.Fullname,
                                        placeholder: 'Pilih Pembantu',
                                        clearable: false,
                                        searchFields: ['Fullname'],
                                        classname: 'custom-select'
                                      }), null, 16, ["modelValue", "id", "fieldLabel"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_28, [
                                    (fields.length === 1)
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: _imports_0,
                                          alt: "delete",
                                          class: "cursor-pointer",
                                          style: {"width":"35px","height":"35px"},
                                          onClick: ($event: any) => (remove(indexX))
                                        }, null, 8, _hoisted_30))
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(`${_ctx.store.state.plotting.selectedConductor.Fullname}`), 1),
                        _createElementVNode("div", _hoisted_34, _toDisplayString(`${_ctx.store.state.plotting.selectedConductor.IdCardNumber}`), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_HjpTabView, {
                          class: "",
                          tabHeader: _ctx.tabHeader,
                          onTabsChange: _ctx.tabsChange
                        }, null, 8, ["tabHeader", "onTabsChange"]),
                        (_ctx.activeTab === 0)
                          ? (_openBlock(), _createBlock(_component_KondekturActiveScheduleList, { key: 0 }))
                          : (_ctx.activeTab === 1)
                            ? (_openBlock(), _createBlock(_component_KondekturLog, { key: 1 }))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    (_ctx.store.state?.headerButton.isShowDialogForm)
      ? (_openBlock(), _createBlock(_component_SelectConductorForm, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmModal, { ref: "refConfirmModal" }, null, 512),
    _createVNode(_component_HjpAlertModal, {
      show: _ctx.modalConfirmation.show,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      subTitleHtml: _ctx.modalConfirmation.subTitleHtml,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      imgContent: _ctx.modalConfirmation.imgContent,
      onHideDialog: _ctx.hideConfirmDialog,
      onOnSubmit: _ctx.hideConfirmDialog
    }, _createSlots({ _: 2 }, [
      (_ctx.currentSchedules.length > 0)
        ? {
            name: "additionalContent",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSchedules, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "w-full grid grid-cols-2 gap-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(data.RegNumber), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_38, _toDisplayString(`PP${data.PpOrder} (${data.DepartureTime})`), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          }
        : undefined
    ]), 1032, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"])
  ]))
}